<template>
  <div class="banner" style="position: absolute;top:70px;z-index:-1;" >
	<div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
		<div class="carousel-inner" role="listbox" v-if="$WebName">
			<div class="item active">
				<img style="height:350px" :src="($resourcesUrl+'/img/banner.jpg')" alt="">
			</div>
			<div class="item">
				<img :src="($resourcesUrl+'/img/banner1.jpg')" alt="">
			</div>
		</div>
    <div class="carousel-inner" role="listbox" v-else>
    	<div class="item active">
    		<img style="height:350px" :src="($resourcesUrl+'/img/banner2.jpg')" alt="">
    	</div>
    	<div class="item">
    		<img :src="($resourcesUrl+'/img/banner.jpg')" alt="">
    	</div>
    </div>
		<a class="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
			<span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
			<span class="sr-only">Previous</span>
		</a>
		<a class="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
			<span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
			<span class="sr-only">Next</span>
		</a>
	</div>
  </div>
</template>

<script>
	import "../js/jquery-1.8.3.min.js"
export default {
	components:{
	},
	data(){
		return {
			dialogVisible: false,
			radio:"",
		}
	},
	mounted() {

	},
	methods:{
		handleClose(done) {
			this.$confirm('确认关闭？')
			.then(_ => {
				done();
			})
			.catch(_ => {});
		}
	}
}
</script>

<style>

	.xhuan{color: #FFFFFF!important;border: none!important;background: #FF6666!important;}

	.banner{width: 100%;position: relative;height: 425px;}
	.banner>#carousel-example-generic{height: 425px;}
	.banner>#carousel-example-generic>.carousel-inner{height: 425px;}
	.banner>#carousel-example-generic>.carousel-inner img{height: 375px;width: 100%;}
	.banner>.content{width: 100%;height: 80px;background-color: rgba(0, 0, 0, 0.452);position: absolute;bottom: 0px;left: 0px;top: auto;overflow: hidden;}
	.banner>.content .location{height: 80px;display: flex;align-items: center;}
	.banner>.content .location>.text{font-size: 15px;color: #fff;line-height: 80px;font-weight: bold;}
	.banner>.content .location>.locationBtn{display: flex;align-items: center;justify-content: center; width: 65px;margin-left: 6px;height: 22px;background-color: #01000048 ;color: #fff;font-size: 16px;line-height: 22px;border-radius: 5px;text-align: center;cursor: pointer;}
	.banner>.content .select{display: flex;height: 80px;align-items: center;justify-content: space-around;}
	.banner>.content .select>.checkbox{margin: 0px;display: flex;align-items: center;cursor: pointer;}
	.banner>.content .select>.checkbox .input{width: 14px;height: 14px;border-radius: 7px;outline: none;border: 1px solid #DEDEDE;box-sizing: border-box;background-color: #00000000;margin-right:3px ;}
	.banner>.content .select>.checkbox{margin: 0px;color: #fff;}
	.banner>.content .select>.checkbox span{color: #FFFFFF;}
	.banner>.content .search{display: flex;align-items: center;height: 80px;}
	.banner>.content .search>div{margin: 0px 3px;}
	.banner>.content .search>.inp{height: 30px;}
	.banner>.content .search>.inp>input{height: 30px;width: 100px;border-radius: 5px;padding: 0px 5px;box-sizing: border-box;display: inline-block;box-sizing: border-box;}
	.banner>.content .search>.searchBtn{height: 30px;width: 80px;flex-shrink: 0;text-align: center;background: linear-gradient(94deg, #FF9804, #F43626);border-radius: 5px;padding: 0px 10px;line-height: 30px;color: #fff;}
	.el-dialog{width: 50%;}




		.banner{width: 100%; min-width:1280px;position: relative;height: 350px;}
		.banner>#carousel-example-generic{height: 350px;}
		.banner>#carousel-example-generic>.carousel-inner{height: 350px;}
		.banner>#carousel-example-generic>.carousel-inner img{height: 350px;width: 100%;}
		.banner>.content{width: 100%;height: 80px;background-color: rgba(0, 0, 0, 0.452);position: absolute;bottom: 0px;left: 0px;top: auto;}
		.banner>.content .location{height: 80px;display: flex;align-items: center;}
		.banner>.content .location>.text{font-size: 18px;color: #fff;line-height: 80px;font-weight: bold;}
		.banner>.content .location>.locationBtn{width: 57px;margin-left: 10px;height: 28px;background-color: #01000048 ;color: #fff;font-size: 16px;line-height: 28px;border-radius: 5px;text-align: center;cursor: pointer;}
		.banner>.content .select{display: flex;height: 80px;align-items: center;justify-content: space-around;}
		.banner>.content .select>.checkbox{margin: 0px;display: flex;align-items: center;cursor: pointer;}
		.banner>.content .select>.checkbox .input{width: 14px;height: 14px;border-radius: 7px;outline: none;border: 1px solid #DEDEDE;box-sizing: border-box;background-color: #00000000;margin-right:3px ;}
		.banner>.content .select>.checkbox{margin: 0px;color: #fff;}
		.banner>.content .search{display: flex;align-items: center;height: 80px;}
		.banner>.content .search>div{margin: 0px 6px;}
		.banner>.content .search>.inp{height: 30px;}
		.banner>.content .search>.inp>input{height: 30px;width: 140px;border-radius: 5px;padding: 0px 5px;box-sizing: border-box;display: inline-block;box-sizing: border-box;}
		.banner>.content .search>.searchBtn{height: 30px;width: 100px;flex-shrink: 0;text-align: center;background: linear-gradient(94deg, #FF9804, #F43626);border-radius: 5px;padding: 0px 10px;line-height: 30px;color: #fff;}

		.el-dialog{width: 60%;}


</style>



// WEBPACK FOOTER //
// src/views/home/banner.vue